import React from 'react';
import { useLocation } from 'react-router-dom';
import './GroomingAppointmentDetail.css';

function GroomingAppointmentDetail() {
  var location = useLocation();
  var booking = location.state && location.state.appointment;

  function formatTime(iso) {
    var date = new Date(iso);
    return date.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return 'N/A';
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumber; // Return original if format is invalid
  };

  if (!booking) {
    return (
      <div className="grooming-detail-loading">
        No appointment data found.
      </div>
    );
  }

  var pet = booking.FamilyMember || {};
  var owner = booking.User || {};
  var grooming = booking.additionalServices && booking.additionalServices.groomingOptions
    ? booking.additionalServices.groomingOptions
    : {};

  return (
    <div className="grooming-detail-container">
      <h2 className="grooming-detail-header">Grooming Detail</h2>

      <div className="grooming-detail-section">
        <h3>
            <span className='pet-name-badge'>{pet.name}</span>
          <span className="pet-type-badge">{pet.type}</span> - {pet.breed}
        </h3>
        <p><strong>Owner:</strong> {owner.username} ({formatPhoneNumber(owner.phone)})</p>
        <p><strong>Status:</strong> {booking.status}</p>
        <p><strong>Start:</strong> {formatTime(booking.startTime)}</p>
        <p><strong>End:</strong> {formatTime(booking.endTime)}</p>
      </div>

      <div className="grooming-detail-section">
        <h4>Service Details</h4>
        <p><strong>Size:</strong> {grooming.selectedSize}</p>
        <p><strong>Package:</strong> {grooming.selectedPackage}</p>
        <p><strong>Haircut Style:</strong> {grooming.selectedHaircutStyle}</p>
        <p><strong>Extras:</strong> {
          grooming.additionalServices && grooming.additionalServices.length > 0
            ? grooming.additionalServices.join(', ')
            : 'None'
        }</p>
      </div>

      <div className="grooming-detail-section">
        <h4>Notes</h4>
        <p>{booking.specialNotes ? booking.specialNotes : 'No special notes provided.'}</p>
      </div>
    </div>
  );
}

export default GroomingAppointmentDetail;
